/**
 * Handle Navigaition Block behaviors
 */
let NavigationPills = {
	/**
	 * Entry point
	 */
	_init: () => {
		document.addEventListener('DOMContentLoaded', NavigationPills._ready);
	},
	/**
	 * Fires when document's loaded & ready
	 */
	_ready: () => {
		const navPillsWrapper = document.querySelector('.navpills');
		
		if (!navPillsWrapper) return;
		
		const navPillsUI = navPillsWrapper.dataset.ui;
		
		if (navPillsUI === 'filters') { 
			navPillsWrapper.addEventListener('click', NavigationPills._handleAllClicks);
		}
	},
	_handleAllClicks: (e) => {
		// Check if the clicked element is a pill
		const pill = e.target.closest('.navpills-wrapper-pills-pill');
		if (pill) {
			e.preventDefault();
			NavigationPills._pillClickHandler(e, pill);
			return;
		}
		
		// Check if the clicked element is a sub-pill
		const subPill = e.target.closest('.navpills-wrapper-subpills-pill');
		if (subPill) {
			e.preventDefault();
			NavigationPills._subPillClickHandler(e, subPill);
			return;
		}
	},
	/**
	 * Fires when a pill is clicked
	 * @param {object} e the event object
	 */
	_pillClickHandler: (e, pill) => {
		// prevent default behavior
		e.preventDefault();
		
		const pills = document.querySelectorAll('.navpills-wrapper-pills-pill');
		const subPills = document.querySelectorAll('.navpills-wrapper-subpills-pill');
		const subPillsWrappers = document.querySelectorAll('.navpills-wrapper-subpills');
		
		const mainCat = pill.dataset.pill;
		const currentSubPills = document.querySelector(`.navpills-wrapper-subpills[data-mainpill="${mainCat}"]`);
		
		pills.forEach(p => p.classList.remove('active'));
		subPills.forEach(sp => sp.classList.remove('active'));
		
		subPillsWrappers.forEach(wrapper => {
			wrapper.classList.add('hidden');
			wrapper.classList.remove('visible');
		});
		
		currentSubPills?.classList.remove('hidden');
		currentSubPills?.classList.add('visible');
		pill.classList.add('active');
		
		const url = new URL(window.location);
		
		if (url.searchParams.get('main_cat')) {
			url.searchParams.delete('main_cat');
		}
		
		if (url.searchParams.get('sub_cat')) {
			url.searchParams.delete('sub_cat');	
		}
		
		url.searchParams.set('main_cat', mainCat);
		
		history.pushState({}, "", url);
		
		e.target.dispatchEvent(new CustomEvent('navigationpill:click', {
			bubbles: true,
			detail: { mainCat: mainCat }
		}))
	},
	_subPillClickHandler: (e, subPill) => { 
		const subPills = document.querySelectorAll('.navpills-wrapper-subpills-pill');
		const subCat = subPill.dataset.subpill;

		subPills.forEach(sp => sp.classList.remove('active'));
		
		subPill.classList.add('active');
		
		const url = new URL(window.location);
		url.searchParams.delete('sub_cat');	
		url.searchParams.set('sub_cat', subCat);
		history.pushState({}, "", url);
		
		e.target.dispatchEvent(new CustomEvent('navigationsubpill:click', {
			bubbles: true,
			detail: { subCat: subCat }
		}))
	},
};
// kick things off.
NavigationPills._init();
